// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/component/component.js#1 $
'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcComponent
* @element ANY
* @description
* # tcComponent
* Adds placeholder for a component, applies CSS class.
*/
angular.module('tcApp')
.value('componentData', null)
.directive('tcComponent', function() {
	var getTemplate = function getTemplate(element) {
		if (element.children().length > 0) {
			return element[0].innerHtml;
		} else {
			// eslint-disable-next-line max-len
			return '<ng-include src="viewModel.templateUrl" ng-class="{componentWithItems: viewModel.containsVisibleItems, componentWithComponents: viewModel.containsVisibleComponents, componentChartDisplay: options.chartDisplay}"></ng-include>';
		}
	};
	return {
			template: getTemplate,
			restrict: 'E',
			scope: {
				componentName: '=',
				data: '=?',
				context: '=?',
				options: '=?'
			},
			controller: 'ComponentCtrl',
		};
});
